(function () {
    'use strict';

    angular
        .module('app.shared')
        .factory('renewRedirect', renewRedirect);

    var parser = document.createElement('a');

    renewRedirect.$inject = ['$window', 'OpenId', 'user', 'culture', 'alert', 'shared_resources', 'renewRedirectUrl'];
    function renewRedirect($window, OpenId, user, culture, alert, resources, renewRedirectUrl) {

        return function renewRedirect(openInNewWindow, uri) {
            var href = uri ? uri : renewRedirectUrl,
                isCustomUri = uri ? true : false,
                newWindow;

            if (user.isClubManagingUpgrades)
                alert.info(resources.contactGolfClubMessage);
            if (href) {
               // classicViewModal().result.then(redirect, redirect);
                redirect();
            }

            function redirect() {
                if (openInNewWindow) {
                    newWindow = $window.open('', '_blank');
                    newWindow.document.write("Loading...");
                }

                if (isCustomUri) {
                    success({ token: null });
                } else {
                    OpenId.getNgnToken(success, error, true);
                }
            }

            function success(data) {
                parser.href = href;
                if (!isCustomUri) {
                    parser.search += (parser.search ? '&' : '?') + encodeURIComponent(isRenewaltoken ? 'renewalToken' : classicViewTokenParam) + '=' + encodeURIComponent(data.token);
                }
                if (openInNewWindow)
                    newWindow.location.href = parser.href; // $window.open(parser.href)
                else
                    $window.location.href = parser.href;
            }
            function error() {
                if (newWindow)
                    newWindow.close();
                alert.error(resources.ngnTokenRequestFailed);
            }
        }
    }
})();
